// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3c1f5b2f","845":"1ad25461"}[chunkId] + ".chunk.js";
};